import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const MathNode = ({ id, data }) => {
  const [operation, setOperation] = useState(data?.operation || 'add');
  
  const config = {
    title: 'Math',
    content: (
      <div className="text-xs text-gray-500 mb-2">
        Perform mathematical operations on inputs
      </div>
    ),
    fields: [
      {
        name: 'operation',
        type: 'select',
        label: 'Operation',
        value: operation,
        onChange: (e) => setOperation(e.target.value),
        options: ['add', 'subtract', 'multiply', 'divide', 'power', 'modulo'],
      },
    ],
    handles: [
      {
        type: 'target',
        position: Position.Left,
        id: `${id}-a`,
        style: { top: '40%' },
      },
      {
        type: 'target',
        position: Position.Left,
        id: `${id}-b`,
        style: { top: '60%' },
      },
      {
        type: 'source',
        position: Position.Right,
        id: `${id}-result`,
      },
    ],
    width: 220,
    height: 140,
  };

  return <BaseNode id={id} data={data} config={config} />;
};